
import { mapState } from 'vuex'

export default {
  data() {
    return {
      color: '',
      make: '',
      model: '',
    }
  },
  mounted() {
    this.color = this.handoff.Color
    this.make = this.handoff.Make
    this.model = this.handoff.Model
    this.order.custom.forEach(field => {
      if (field.label == 'Color') {
        this.color = field.value
      }
      if (field.label == 'Make') {
        this.make = field.value
      }
      if (field.label == 'Model') {
        this.model = field.value
      }
    })
    let handoff = JSON.parse(JSON.stringify(this.handoff))
    handoff.Color = this.color
    handoff.Make = this.make
    handoff.Model = this.model
    this.$store.commit('setHandoff', handoff)
  },
  computed: {
    ...mapState(['handoff','order','channel']),
  },
  methods: {
    async updateDetails() {
      let handoff = JSON.parse(JSON.stringify(this.handoff))
      handoff.Color = this.color
      handoff.Make = this.make
      handoff.Model = this.model
      this.$store.commit('setHandoff', handoff)
      const fields = []
      this.order.custom.map((c) => {
        if (this.handoff[c.label]) {
          fields.push({
            id: c.id,
            value: this.handoff[c.label]
          })
        }
      })
      await this.$api.setCustomFields(fields)
    },
    async setHandoff(mode) {
      if (mode == 'dispatch') {
        this.$router.push('/locations?mode=delivery')
      } else {
        await this.$api.setHandoff(mode)
      }
    },
  }
}
